import React from "react";
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Flex,
  Text,
  Icon,
} from "@chakra-ui/react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import {
  newBorder,
  white,
  primary,
  buttonBlueDark,
  buttonAltGrey,
  textSecondary,
  buttonAltGreen,
  buttonGreenDark,
  buttonGreenText,
  buttonAltPrimary,
  buttonAltYellow,
  buttonYellowDark,
  buttonYellow,
  buttonAltRed,
  buttonRedDark,
  buttonRedText,
  buttonAltSuccess,
  buttonGreenVividDark,
  textPrimary,
  buttonBlue,
  buttonRed,
  buttonGreen,
  text,
  color8,
  color2,
  color3,
  color6,
  color5,
  color4,
  color1,
} from "../../utils/colors";
import {
  FaRegCircleDot,
  FaRegCircle,
  FaCircleCheck,
  FaClock,
  FaCircleHalfStroke,
  FaCircleXmark,
} from "react-icons/fa6";
import { useTranslation } from "react-i18next";

const FormControlStatus = ({
  label,
  value,
  onChange,
  isRequired,
  isTouched,
  isError,
  errorMessage,
  w,
  isSmall,
  options,
  isMulti,
  mb,
}) => {
  const { t } = useTranslation();
  const translate = (key) => t(key);

  const animatedComponents = makeAnimated();

  if (options === "user") {
    options = [
      {
        value: "new",
        label: translate("status.patientNew"),
        icon: FaRegCircleDot,
        bg: color8,
        bgDark: buttonBlueDark,
        color: textPrimary,
        borderColor: buttonBlue,
        bgHover: "#b6cce1",
      },
      {
        value: "inactive",
        label: translate("status.patientInactive"),
        icon: FaRegCircle,
        bg: buttonAltGrey,
        bgDark: textSecondary,
        color: text,
        borderColor: buttonAltGrey,
        bgHover: "#ddd",
      },
      {
        value: "planningTreatment",
        label: translate("status.patientPlanningTreatment"),
        icon: FaClock,
        bg: color2,
        bgDark: buttonYellowDark,
        color: white,
        borderColor: buttonYellow,
        bgHover: "#9ebfc2",
      },
      {
        value: "approvedTreatment",
        label: translate("status.patientApprovedTreatment"),
        icon: FaCircleCheck,
        bg: color3,
        bgDark: buttonGreenDark,
        color: white,
        borderColor: buttonAltGreen,
        bgHover: "#9ebfc2",
      },
      {
        value: "ongoingTreatment",
        label: translate("status.patientOngoingTreatment"),
        icon: FaCircleHalfStroke,
        bg: color4,
        bgDark: buttonYellowDark,
        color: white,
        borderColor: buttonAltYellow,
        bgHover: "#9ebfc2",
      },

      {
        value: "completedTreatment",
        label: translate("status.patientCompletedTreatment"),
        icon: FaCircleCheck,
        bg: color5,
        bgDark: buttonGreenVividDark,
        color: textPrimary,
        borderColor: buttonAltSuccess,
        bgHover: "#dda3a3",
      },
      {
        value: "cancelledTreatment",
        label: translate("status.patientCancelledTreatment"),
        icon: FaCircleXmark,
        bg: color6,
        bgDark: buttonRedDark,
        color: white,
        borderColor: buttonRed,
        bgHover: "#dda3a3",
      },
    ];
  } else if (options === "treatment") {
    options = [
      {
        value: "planning",
        label: translate("status.treatmentPlanPlanning"),
        icon: FaClock,
        bg: color2,
        bgDark: buttonYellowDark,
        color: white,
        borderColor: buttonYellow,
        bgHover: "#9ebfc2",
      },
      {
        value: "approved",
        label: translate("status.treatmentPlanApproved"),
        icon: FaCircleCheck,
        bg: color3,
        bgDark: buttonGreenDark,
        color: white,
        borderColor: buttonGreen,
        bgHover: "#9ebfc2",
      },
      {
        value: "ongoing",
        label: translate("status.ongoing"),
        icon: FaCircleHalfStroke,
        bg: color4,
        bgDark: buttonYellowDark,
        color: white,
        borderColor: buttonAltYellow,
        bgHover: "#9ebfc2",
      },
      {
        value: "completed",
        label: translate("status.treatmentPlanCompleted"),
        icon: FaCircleCheck,
        bg: color5,
        bgDark: buttonGreenDark,
        color: textPrimary,
        borderColor: buttonGreen,
        bgHover: "#9ebfc2",
      },
      {
        value: "cancelled",
        label: translate("status.treatmentPlanCancelled"),
        icon: FaCircleXmark,
        bg: color6,
        bgDark: buttonRedDark,
        color: white,
        borderColor: buttonRed,
        bgHover: "#dda3a3",
      },
    ];
  } else if (options === "patient") {
    options = [
      {
        value: "new",
        label: translate("patientStatus.new"),
        icon: FaRegCircleDot,
        bg: color8,
        bgDark: buttonBlueDark,
        color: textPrimary,
        borderColor: buttonBlue,
        bgHover: "#b6cce1",
      },
      {
        value: "inactive",
        label: translate("patientStatus.inactive"),
        icon: FaRegCircle,
        bg: buttonAltGrey,
        bgDark: textSecondary,
        color: text,
        borderColor: buttonAltGrey,
        bgHover: "#ddd",
      },

      {
        value: "planningTreatment",
        label: translate("patientStatus.planningTreatmentFull"),
        icon: FaClock,
        bg: color2,
        bgDark: buttonYellowDark,
        color: white,
        borderColor: buttonYellow,
        bgHover: "#9ebfc2",
      },
      {
        value: "approvedTreatment",
        label: translate("patientStatus.approvedTreatmentFull"),
        icon: FaCircleCheck,
        bg: color3,
        bgDark: buttonGreenDark,
        color: white,
        borderColor: buttonAltGreen,
        bgHover: "#9ebfc2",
      },
      {
        value: "ongoingTreatment",
        label: translate("patientStatus.ongoingTreatmentFull"),
        icon: FaCircleHalfStroke,
        bg: color4,
        bgDark: buttonYellowDark,
        color: white,
        borderColor: buttonAltYellow,
        bgHover: "#9ebfc2",
      },
      {
        value: "cancelledTreatment",
        label: translate("patientStatus.cancelledTreatmentFull"),
        icon: FaCircleXmark,
        bg: color6,
        bgDark: buttonRedDark,
        color: white,
        borderColor: buttonRed,
        bgHover: "#dda3a3",
      },
      {
        value: "completedTreatment",
        label: translate("patientStatus.completedTreatmentFull"),
        icon: FaCircleCheck,
        bg: buttonAltSuccess,
        bgDark: buttonGreenVividDark,
        color: textPrimary,
        borderColor: buttonAltSuccess,
        bgHover: "#dda3a3",
      },
    ];
  } else {
    options = [
      {
        value: "inactive",
        label: translate("status.inactive"),
        icon: FaRegCircle,
        bg: buttonAltGrey,
        bgDark: textSecondary,
        color: text,
        borderColor: buttonAltGrey,
        bgHover: "#ddd",
      },

      {
        value: "active",
        label: translate("status.active"),
        icon: FaCircleCheck,
        bg: buttonAltGreen,
        bgDark: buttonGreenDark,
        color: buttonGreenText,
        borderColor: buttonAltGreen,
        bgHover: "#9ebfc2",
      },
    ];
  }

  // Custom rendering for options and selected values
  const formatOptionLabel = (option, { context }) => (
    <Flex
      align="center"
      w="initial"
      // bg={context === "menu" ? option.bg : "inherit"}
    >
      {option.icon && (
        <Flex
          align="center"
          justify="center"
          mr={context === "menu" ? 2 : 1}
          bg={context === "menu" ? option.bg : "inherit"}
          w="16px"
          h="16px"
          borderRadius="2rem"
          flexShrink="0"
        >
          <Icon
            fontSize="8px"
            as={option.icon}
            color={context === "menu" ? option.color : "inherit"}
            flexShrink="0"
          />
        </Flex>
      )}

      <Text
        fontSize={context === "menu" ? "13px" : "xs"}
        fontWeight="500"
        // color={context === "menu" ? textSecondary : option.color}
      >
        {option.label}
      </Text>
    </Flex>
  );

  // console.log("value", value);

  // Custom styles for react-select
  const customStyles = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: isError ? "red" : state.isFocused ? newBorder : newBorder,
      borderRadius: "1rem",
      backgroundColor: white,
      border: `1px solid ${newBorder}`,
      fontSize: isSmall ? "0.875rem" : "0.938rem",
      fontWeight: "500",
      minHeight: "2.5rem",
      height: isMulti ? "initial" : isSmall ? "2.5rem" : "3rem",
      padding: "0 0rem",
      ":focus-visible": {
        borderColor: primary,
        boxShadow: `0 0 0 1px ${newBorder}`,
      },
      ":hover": {
        cursor: "pointer",
      },
    }),

    singleValue: (provided, state) => ({
      ...provided,
      opacity: state.isDisabled ? 0.5 : 1,
      color: textPrimary,
    }),

    menu: (provided) => ({
      ...provided,
      overflow: "hidden",
      borderRadius: "0.75rem",
    }),

    menuList: (provided) => ({
      ...provided,
      padding: 0,
      margin: 0,
    }),

    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? primary : null,
      color: state.isFocused ? white : textSecondary,
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      ":hover": {
        color: white,
      },
    }),
    multiValue: (provided, state) => ({
      ...provided,
      backgroundColor: state.data.bg,
      borderRadius: "0.75rem",
      fontSize: "0.938rem",
    }),
    multiValueLabel: (provided, state) => ({
      ...provided,
      color: state.data.color,
    }),
    multiValueRemove: (provided, state) => ({
      ...provided,
      ":hover": {
        backgroundColor: buttonRed,
        color: buttonRedText,
      },
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontSize: "11px",
      color: textSecondary,
      fontWeight: "500",
    }),
  };

  // Function to check if the options are grouped
  const areOptionsGrouped = (options) =>
    options.some((option) => option.options);

  // Function to find the option object for a given value
  const findOption = (valueToFind, options, isGrouped) => {
    if (isGrouped) {
      for (const group of options) {
        const foundOption = group.options.find(
          (opt) => opt.value === valueToFind
        );
        if (foundOption) return foundOption;
      }
    } else {
      return options.find((opt) => opt.value === valueToFind);
    }
    return null;
  };

  // Determine if options are grouped
  const isGrouped = areOptionsGrouped(options);

  // Map each value to its corresponding option object
  const selectedOption = Array.isArray(value)
    ? value
        .map((val) => findOption(val, options, isGrouped))
        .filter((opt) => opt !== null)
    : findOption(value, options, isGrouped);

  // console.log("options", options);
  console.log("value", value);

  return (
    <FormControl
      mb={mb ? mb : 4}
      isRequired={isRequired}
      isInvalid={isTouched && isError}
      w={w}
    >
      <FormLabel fontSize={isSmall ? "xs" : "sm"} position="relative">
        {label}
        {isError && isTouched && (
          <div>
            <FormErrorMessage fontSize="xs">{errorMessage}</FormErrorMessage>
          </div>
        )}
      </FormLabel>

      <Select
        closeMenuOnSelect={false}
        components={animatedComponents}
        formatOptionLabel={formatOptionLabel}
        isSearchable
        value={selectedOption}
        isMulti={isMulti}
        onChange={(selected) => {
          // Call the onChange prop passed from PatientFilterPopover
          onChange(selected);
        }}
        options={options}
        placeholder={t("placeholder.selectStatus")}
        styles={customStyles}
        noOptionsMessage={() => t("placeholder.noOptions")}
      />
    </FormControl>
  );
};

export default FormControlStatus;
